import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

const GOLD = '#e53935';
const GOLD_DIM = '#c62828';
const STEEL = 'rgba(255,255,255,0.35)';

/** Icône serveur dédié — popup offre licence New */
export const DedicatedServerIcon: React.FC<IconProps> = ({ className = '', size = 40 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="6"
      y="8"
      width="28"
      height="24"
      rx="3"
      stroke={GOLD_DIM}
      strokeWidth="1.25"
      fill="rgba(229, 57, 53,0.06)"
    />
    <rect x="9" y="12" width="22" height="6" rx="1.5" fill="rgba(255,255,255,0.04)" stroke={STEEL} strokeWidth="0.75" />
    <rect x="9" y="21" width="22" height="6" rx="1.5" fill="rgba(255,255,255,0.04)" stroke={STEEL} strokeWidth="0.75" />
    <circle cx="12.5" cy="15" r="1.25" fill={GOLD}>
      <animate attributeName="opacity" values="0.5;1;0.5" dur="2.4s" repeatCount="indefinite" />
    </circle>
    <circle cx="12.5" cy="24" r="1.25" fill={GOLD_DIM} opacity="0.7" />
    <path d="M16 15h12M16 24h8" stroke={STEEL} strokeWidth="1" strokeLinecap="round" />
    <path
      d="M20 32v4M14 36h12"
      stroke={GOLD_DIM}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeOpacity="0.8"
    />
    <path
      d="M20 4v4"
      stroke={GOLD}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="20" cy="3" r="1.5" fill={GOLD} opacity="0.9">
      <animate attributeName="opacity" values="0.6;1;0.6" dur="1.8s" repeatCount="indefinite" />
    </circle>
    <path
      d="M4 20H6M34 20h2"
      stroke={GOLD_DIM}
      strokeWidth="1"
      strokeLinecap="round"
      strokeOpacity="0.5"
    />
  </svg>
);
